import GlobalLoading from "./GlobalLoading";
export default GlobalLoading;
